import React, { useEffect, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { clearStoredLoginRedirect, getSafeLoginRedirect } from '../utils/loginRedirect';

const AuthenticatedLoginRedirect = ({ fallback }) => {
  const location = useLocation();
  const intendedDestination = useMemo(
    () => getSafeLoginRedirect(location.search),
    [location.search]
  );

  useEffect(() => {
    clearStoredLoginRedirect();
  }, []);

  return <Navigate to={intendedDestination || fallback} replace />;
};

export default AuthenticatedLoginRedirect;
